import { acquisitionAmountToNumber } from '../acquisition/acquisitionAmount';

const percentFormatter = new Intl.NumberFormat('it-IT', {
  maximumFractionDigits: 2,
});

/**
 * The requested amount as a share of the property value, e.g. "66,67%";
 * `null` when either figure is missing or the share exceeds 100%.
 */
export const leadTassoLoanToValueLabel = (
  loanAmountDisplay: string,
  propertyValueDisplay: string
): string | null => {
  const loanAmount = acquisitionAmountToNumber(loanAmountDisplay);
  const propertyValue = acquisitionAmountToNumber(propertyValueDisplay);
  if (loanAmount === null || propertyValue === null) return null;

  const share = (loanAmount / propertyValue) * 100;
  return share > 100 ? null : `${percentFormatter.format(share)}%`;
};
